import { styled } from "@mui/material";

import { Text } from "../../shared/uiComponents";
import { white100 } from "../../shared/Helpers/colors";
import { useScreenWidth } from "../../shared/Helpers/hooks";
import Illuminate from "../../shared/Assets/logos/IlluminateLogoMain.png";
import { AdminTypes } from "../../components/Menu";
import { IMG } from "../../components/Menu/styledComponents";
import { Loader } from "../../components/StyledComponents";
import BCBA from "./authorizationsInfoBCBA";
import Admin from "./authorizationsInfoAdmin";
import ClinicalSupervisor from "./authorizationsInfoClinicalSupervisor";

import { useSelector } from "../../redux/store";

export const Container = styled("div")(() => ({
  backgroundColor: white100,
  width: "100%",
  padding: "24px",
  borderRadius: "12px",
  minWidth: "720px",
  maxWidth: "1440px",
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  ">div": {
    width: "max-content",
  },
  "@media (max-width: 768px)": {
    minWidth: "220px",
    padding: "8px",
  },
}));

const Dashboard = () => {
  const loadingAccount = useSelector((state) => state.account.loading);
  const role = useSelector((state) => state.account.role);
  const screenWidth = useScreenWidth();
  const isMobile = screenWidth < 768;
  const isTablet = screenWidth < 1024 && screenWidth >= 768;

  return (
    <Container>
      <Text title={"Welcome"} size="largeBold" className="marginTop16" />
      <IMG src={Illuminate} style={{ width: isTablet ? "80%" : isMobile ? "100%" : "40%" }} />
      {AdminTypes.bcba === role?.section.id && <BCBA />}
      {AdminTypes.admin === role?.section.id && <Admin />}
      {AdminTypes.cs === role?.section.id && <ClinicalSupervisor />}
      {loadingAccount && <Loader />}
    </Container>
  );
};

export default Dashboard;
